type AdtSplashLogoProps = Readonly<{
  size?: number
  clipPathId?: string
  fill?: string
  className?: string
}>

const logoPaths = [
  'M40 11.7119V28.2881L28.2793 40H11.7188L0 28.2881V11.7119L11.7188 0H28.2793L40 11.7119ZM5.28418 26.7275H8.90137L9.59082 25.4023H15.0049L15.6758 26.7275H19.2949L19.166 26.4746H20.5166C24.2322 26.4746 27.0195 23.7073 27.0195 19.9902C27.0195 18.7168 26.6929 17.5567 26.1133 16.582H27.377V26.7275H30.7051V16.582H34.5566V13.3076H23.5596V14.2188C22.6622 13.7719 21.6313 13.5234 20.5166 13.5234H16.127V20.5107L12.2988 12.999L5.28418 26.7275ZM20.5166 16.3467C22.6654 16.3467 24.1961 17.8228 24.1963 19.9902C24.1963 22.1579 22.6656 23.6338 20.5166 23.6338H18.9502V16.3467H20.5166ZM13.3691 22.2158H11.207L12.2969 20.1084L13.3691 22.2158Z',
  'M34.3026 13.5596V16.3298H30.4529V26.475H27.6295V16.3298H23.8115V13.5596H34.3041M34.8085 13.0552H23.307V16.8285H27.125V26.9737H30.9531V16.8285H34.8042V13.0552H34.8085Z',
  'M12.2971 13.5538L18.8809 26.475H15.8282L15.158 25.1504H9.43756L8.74863 26.475H5.69598L12.2971 13.5538ZM10.7967 22.4682H13.7802L12.2971 19.5554L10.7967 22.4682ZM12.2985 12.4441L11.8488 13.3247L5.24775 26.2458L4.8658 26.9794H9.04553L9.18966 26.707L9.73735 25.6549H14.8409L15.3713 26.7027L15.5155 26.9794H19.6952L19.3219 26.2458L12.7468 13.3247L12.2985 12.4441ZM11.6254 21.9565L12.2956 20.6594L12.9586 21.9565H11.6254Z',
] as const

export function AdtSplashLogo({
  size = 120,
  clipPathId = 'adt-splash-clip',
  fill = '#ffffff',
  className,
}: AdtSplashLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className={className}
    >
      <g clipPath={`url(#${clipPathId})`}>
        {logoPaths.map((d) => (
          <path key={d.slice(0, 24)} d={d} fill={fill} />
        ))}
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
